export const API_ROUTE = "/api/my-fans/brand-data";